module.exports = "/assets/data/6d356ac9be47ee8911e573460d592837-NE4.data.json";